import { Sun, Moon } from "@phosphor-icons/react";
import { useTheme } from "../lib/theme";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button data-testid="theme-toggle" onClick={toggle}
      title={isDark ? "Switch to light" : "Switch to dark"}
      className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/[0.05] text-white/85 transition hover:text-white">
      {isDark ? <Sun size={18} weight="fill" className="text-neon-amber" /> : <Moon size={18} weight="fill" className="text-neon-cyan" />}
    </button>
  );
}
